import { Routes } from "@angular/router";
import { HomeComponent } from "./home/home.component";
import { AuthGuard } from "./core/guards/auth.guard";
import { WatchDetailComponent } from "./shared/components/watch/watch-detail/watch-detail.component";
import { WatchEditComponent } from "./shared/components/watch/watch-edit/watch-edit.component";
import { MainLayoutComponent } from "./layout/main-layout/main-layout.component";
import { PublishWatchComponent } from "./market/publish-watch/publish-watch.component";
import { AccessDeniedComponent } from "./shared/components/access-denied/access-denied.component";
import { hasRoleGuard } from "./core/guards/has-role.guard";
import { Role } from "./shared/data-types/roles.enum";

export const routes: Routes = [
  { path: "", redirectTo: "home", pathMatch: "full", data: { breadcrumb: "Home" } },
  {
    path: "",
    component: MainLayoutComponent,
    children: [{ path: "home", component: HomeComponent }],
  },
  {
    path: "auth",
    loadChildren: () => import("./auth/auth.module").then((m) => m.AuthModule),
    data: { breadcrumb: "Auth" },
  },

  {
    canMatch: [AuthGuard],
    path: "",
    component: MainLayoutComponent,
    children: [
      {
        path: "watch/:id",
        component: WatchDetailComponent,
        data: { breadcrumb: "Watch Details" },
      },
      {
        path: "edit-watch/:id",
        component: WatchEditComponent,
        data: { breadcrumb: "Edit Watch" },
      },
      {
        path: "publish-watch",
        component: PublishWatchComponent,
        data: { breadcrumb: "Publish Watch" },
      },
      {
        path: "admin",
        canActivate: [hasRoleGuard([Role.ADMIN])],
        loadChildren: () => import("./administration/administration.module").then((m) => m.AdministrationModule),
        data: { breadcrumb: "Admin" },
      },
      {
        path: "market",
        loadChildren: () => import("./market/market.module").then((m) => m.MarketModule),
        data: { breadcrumb: "Market" },
      },
      {
        path: "user",
        loadChildren: () =>
          import("./user-marketplace/user-marketplace.module").then(
            (m) => m.UserMarketplaceModule
          ),
        data: { breadcrumb: "User" },
      },
    ],
  },

  { path: "access-denied", component: AccessDeniedComponent, data: { breadcrumb: "Access Denied" } },
  { path: "**", redirectTo: "home", data: { breadcrumb: "Home" } },
];
